
import StoryblokComponent from '~/components/Storyblok/Component'
import breakpointMixin from '~/mixins/breakpoints'

export default {
  components: {
    StoryblokComponent,
  },
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      pinSelectedId: '',
    }
  },
  computed: {
    containerStyles() {
      const styles = {}

      styles.padding = ``

      return styles
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
      // this.setNavColorChangeScrollTrigger()
    })
  },
  methods: {
    init() {
      this.$gsap.context(() => {
        this.$gsap.set('.stroke-1', {
          opacity: 0,
        })

        const tl = this.$gsap.timeline({})

        tl.from('.avatar', {
          alpha: 0,
          // delay: 0.5,
          // scale: 0.5,
          duration: 1,
          y: -20,
          stagger: 0.1,
          ease: 'bounce',
          onComplete: () => {
            if (!this.$matchMedia('sm')) {
              return
            }

            const tweenProperty = (target, prop, min, max) => {
              const randomDur = this.$gsap.utils.random(3, 6, 0.2, true)
              const randomDelay = this.$gsap.utils.random(0.6, 2, 0.2, true)

              this.$gsap.to(target, {
                [prop]: this.$gsap.utils.random(min, max),
                duration: randomDur(),
                delay: randomDelay(),
                ease: 'none',
                onComplete: tweenProperty,
                onCompleteParams: [target, prop, min, max],
              })
            }

            // Animate the properties individually
            this.$gsap.utils.toArray('.avatar').forEach((star) => {
              // tweenProperty(star, "scale", 0.5, 4);
              tweenProperty(star, 'x', -12, 12)
              tweenProperty(star, 'y', -12, 12)
            })
          },
        })
        tl.fromTo(
          '.stroke-2',
          { drawSVG: '0% 0%' },
          {
            drawSVG: '80% 100%',
            duration: 5,
            ease: 'none',
            stagger: 2,
            repeat: -1,
          },
          '>+.3'
        )
        tl.to(
          '.stroke-1',
          {
            opacity: 0.3,
            duration: 0.5,
          },
          '<+.1'
        )
      }, this.$el)
    },

    setId(id) {
      this.pinSelectedId = id
    },
  },
}
